import LdPlans, { planIds } from 'lion-vue-src/config/plans';
import { mapState, mapGetters } from 'vuex';
import { GATED_ACTIONS } from '@/Core/config/gated-actions';
import { REGISTRATION_STATES } from '../../Text/config/registrationStatus';

export default {
  data() {
    return {
      gatedActions: GATED_ACTIONS,
    };
  },
  computed: {
    ...mapState({
      userToGate: state => state.userInformation.user,
      hasRegisterIn10DLC: state => state.conversations.has10dlcRegister,
      registrationStatus10dlc: state => state.conversations.registrationStatus10dlc,
      isTextingBlocked: state => state.userSmsErrorRates.isPermaBlocked,
    }),
    ...mapGetters({
      userHasFeatureFlag: 'userInformation/userHasFeatureFlag',
    }),
    gatedAction() {
      if (!LdPlans || !this.userToGate) return this.gatedActions.Blocked;

      const { txt_plan: userPlan, active_items: activeItems, txt_status: status } = this.userToGate.subscriptionOverview;
      const { id_item: idItem, id_chargebee: idChargebee } = this.userToGate.subscriptionOverview.details;

      if (userPlan && userPlan.toLowerCase() == LdPlans.Trial.toLowerCase()) {
        return this.gatedActions.Blocked;
      }

      const plansRequired = [LdPlans.ProPlus, LdPlans.Elite, LdPlans.CRM, LdPlans.CRMPremier, planIds.LeadsPlus, planIds.LeadBoost, planIds.PAB];
      const hasValidPlan = idItem && plansRequired.some(substring => idItem.includes(substring));
      const hasCustomNumberAddon = activeItems &&
        (activeItems.includes('custom-liondesk-number') ||
          activeItems.some(item => item.includes('custom-number')));
      const hasFreeAccount = (status && status === LdPlans.Free) || (idChargebee && idChargebee.toLowerCase() === 'liondesk_staff');
      const customNumber = this.userToGate.custom_number;

      if (this.isTextingBlocked) return this.gatedActions.ComplianceViolationBlocked;

      if ((hasValidPlan || hasCustomNumberAddon || hasFreeAccount) && !customNumber) return this.gatedActions.SetCustomNumber;

      const validRegister = this.hasRegisterIn10DLC && this.registrationStatus10dlc && this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_COMPLETED;
      if (!validRegister && customNumber) return this.gatedActions.Register10DLC;

      if (!customNumber) return this.gatedActions.Blocked;

      return this.gatedActions.NoAction;
    },
  },
};
